import { EditCommentModal } from 'components/EditCommentModal';
import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimUpdateWorkOrderChangePriceRationaleGql } from './bimWorkOrderChangeJustificationEditQueries';

type TJustificationEditProps = {
    onClose: () => void;
    onSuccess: () => void;
    defaultValue: string | undefined | null;
    workOrderChangePriceId: number;
};

export const BimWorkOrderChangeJustificationEdit = ({
    onClose,
    defaultValue,
    onSuccess,
    workOrderChangePriceId,
}: TJustificationEditProps) => {
    const dispatch = useDispatch();

    const onSuccessUpdate = useCallback(() => {
        onSuccess();
        onClose();
    }, [onClose, onSuccess]);

    const [, status, , request] = useRequest({
        requestId: 'bimWorkOrderChangeJustificationEdit',
        query: bimUpdateWorkOrderChangePriceRationaleGql,
        dependenciesUpdater: onSuccessUpdate,
        withEffect: false,
    });

    const updateInProgress = status === RequestStatus.FETCHING;

    const onSubmit = useCallback(
        ({ value }: { value: string | null | undefined }) => {
            if (value && workOrderChangePriceId) {
                dispatch(request({ workOrderChangePriceId, input: { rationale: value } }));
            }
        },
        [dispatch, request, workOrderChangePriceId],
    );

    return (
        <EditCommentModal
            isOpened
            modalTitle="Обоснование сметы"
            defaultValue={defaultValue}
            onClose={onClose}
            onSubmit={onSubmit}
            isCommit={updateInProgress}
        />
    );
};

BimWorkOrderChangeJustificationEdit.displayName = 'BimWorkOrderChangeJustificationEdit';
